import config from "../../../config";

export const DEFAULT_DOMAIN = config.dev.domain; //'omnicasa.com';

export default {
    default: "properties",
    new: "properties/new",
    config: "properties/configs",
    paramId: "properties/:id",
    detail: "properties/:id",
    search: "properties/search",
    preview: "properties/:id/preview",
    paging: "properties/paging",
    quickSearch: "properties/quicksearch",
    quickLinks: "properties/:id/quick-links",
    smartSuggestion: "properties/smart-suggestion",
    relationById: "properties/:personid/relation/:id",
    relation: "properties/relation",
    addRelation: "properties/:id/relations",
    proposal: "properties/:id/proposal",
    property: "properties/:id/properties",
    demand: "properties/:id/proposal-demand",
    matching: "properties/matching/:demandId",
    matchingCount: "properties/count-matching/:demandId",
    history: "properties/:id/histories",
    documents: "properties/GetAllDocuments",
    documentRequestInfo: "properties/:id/document-request-info",
    sendDocumentRequest: "properties/:id/send-document-request",
    pictures: "properties/GetAllPictures",
    loadContentByTabName: "properties/:id/load-tab/:tab",
    getQuickSearchPropeties: "properties/quicksearch?text=:ids&type=ids",
    getQuickSearchProjects: "projects/quicksearch?text=:ids&type=ids",
    token2Condition: "properties/populate-condition/token2Detail",
    getPointObject: "properties/:id/poi-object",
    getPropertyEnvironmentPicture: "files/properties/:id/situation-pictures",
    getFullUrlFromStorage: "files/publish-document",
    //getPriceBaseIndex: 'properties/renter-price-base-index/{rentdate}?startRentDate={0}&postCode={1}',
    getPriceBaseIndex:
        "properties/{id}/renter-price-base-index?signatureRentDate={sigdate}&startRentDate={rentdate}&postCode={postcode}&typeOfProperty={typeprop}",
    getPropertyDetailViewMode: "properties/:id/preview",
    getPropertyTabViewMode: "properties/:id/load-tab-in-preview/:tab",
    getMediaPubPlans: "properties/:id/lookup-data/mediapubplans",
    regenerateMediaPubPlans: "properties/:id/regenerate-media-pub-plans",
    resetMediaPubPlans: "properties/:id/reset/mediapubplans",
    generateMediaPubPlans: "properties/:id/generate-media-pub-plans",
    changeInfoPubPlans: "properties/:id/change-media-pub-plan/:action",
    clone: "properties/:id/clone",
    getImportUnitTemplate: "projects/units-template",
    exportBuidingUnits: "projects/export-units",
    importBuildingUnits: "projects/import-units",
    importBuildingUnit: "projects/import-each-unit",
    cloneProject: "projects/:id/clone",
    getBoosterInfo: "properties/boosters/info",
    boostObject: "properties/boosters",
    revertBooster: "properties/boosters/revert",
    heritageList: "common/lookup-data/HeritageType",
    verifyHeritage: "properties/heritages",
    parseExcelFile: "projects/parse-excel-units",
    publishMijnVerhuis: "properties/:id/publish-mijnverhuis",
    publishSmooved: "properties/:id/publish-smooved",
    hasSmooved: "properties/:id/has-smooved",
    autoIndex: "properties/auto-index",
    undoAutoIndex: "properties/undo-auto-index",
    publishRealSmart: "/properties/:id/publish-realSmart",
    deleteRealSmart: "/properties/:id/delete-realSmart",
    publishCertinergie: "/properties/:id/publish-certinergie",
    publishCertiplus: "/properties/:id/publish-certiplus",
    publishKeuringsPlatform:
        "properties/:id/publish-keuringsplatform/:keuringOrderId",
    getKeuringsPlatformOrder: "properties/:id/keuringsplatform-orders",
    generateEnergyPerformanceUrl:
        "properties/:id/generate-energy-performance/:supplierName",
    invoiceCommission: "properties/:id/commissions",
    generateInvoiceNumber: "properties/:id/GenerateInvoice",
    invoicePrefill: "invoice/:id/prefill",
    invoiceSend: "invoice/:id/send",
    invoiceUpdateNumber: "invoice/:id/invoice-number",
    invoiceUrl: "invoice/:id/url",
    chartData: "properties/:id/chart",
    checkingBrochure: "brochure/checking-key",
    getDataBrochure: "brochure/:id/getting-valid-data",
    postDataBrochure: "brochure/pushing-data",
    deleteAll: "/properties/delete-all",
    signDocument: "/sign-document/send",
    eideasySignDocument: "/eideasy-sign-document/document/prepare",
    supportSigningMethods: "/eideasy-sign-document/document/supportedmethods",
    signDocumentOrder: "/sign-document/:propertyId/get-signer/:documentId",
    getSignDocumentStatus: "/sign-document/property/:id",
    getSignDocumentStatusDetail: "/sign-document/status/:id",
    getSignDocumentDisplayStatus: "/sign-document/checkaccountinfo",
    paymentRequest: "/payments/insert",
    getDeclineDate: "/properties/relation/get-decline-date",
    addCostFromRelation: "/properties/relation/add-cost",
    getSignDocument: "/sign-document/search",
    getEIDEasySignDocument: "/eideasy-sign-document/search",
    getSignTagByDocumentId: "/eideasy-sign-document/document/signtags/:id",
    recallSignDocument: "/sign-document/document/{id}/recall",
    recallEIDEasySignDocument: "/eideasy-sign-document/delete",
    getOrdersSuppliers:
        "/properties/:id/energy-performance-orders/:supplierName",
    getPropertiesRelation: "/properties/relation-idnames/:id",
    getPropertyPubtext: "/properties/:id/load-tab/:tab",
    publishKorfine: "/properties/:id/publish-korfine",
    cancelKorfine: "/properties/:id/cancel-korfine",
    translateProperties: "/properties/translate-description-info",
    translateProjects: "/projects/translate-description-info",
    postTranslateProperty: "/properties/:id/translate-description",
    postTranslateMultipleProperty: "/properties/multi-translate-description",
    postTranslateProject: "/projects/:id/translate-description",
    getPropertySupplier: "properties/:id/suppliers"
};

export const PROPERTY_URI = {
    PROPERTY_ENVIRONMENT_UPLOAD: "files/:module/upload-situation-picture/:type",
    PROPERTY_PICTURE_UPLOAD: "files/upload-picture?type=ObjectPicture&tab=6",
    PROPERTY_EXTRACT_PDF_TO_PICTURE_UPLOAD: "/files/upload-picture-other-source/pdf?extract=true&type=ObjectPicture",
    PROPERTY_GOOGLE_MAP_STREET_VIEW:
        "https://maps.googleapis.com/maps/api/streetview?size={0}&location={1}&fov={2}&heading={3}&pitch={4}&key={5}"
};

export const AI_URI = {
    TITLE_GENERATION: `https://omnicasa-ai.${DEFAULT_DOMAIN}/ai/title`,
    DESCRIPTION_GENERATION: `https://omnicasa-ai.${DEFAULT_DOMAIN}/ai/description`,
    DESCRIPTION_GENERATION_STREAM: `https://omnicasa-ai.${DEFAULT_DOMAIN}/ai/description-stream`,
    PROJECT_DESCRIPTION_GENERATION: `https://omnicasa-ai.${DEFAULT_DOMAIN}/ai/project`,
    PROJECT_DESCRIPTION_GENERATION_STREAM: `https://omnicasa-ai.${DEFAULT_DOMAIN}/ai/project-stream`,
    EMAIL_GENERATION: `https://omnicasa-ai.${DEFAULT_DOMAIN}/ai/email`,
    IMAGE_ENHANCEMENT: `https://omnicasa-ai.${DEFAULT_DOMAIN}/image-iframe`,
    PDF_EXTRACTION: `https://omnicasa-ai.${DEFAULT_DOMAIN}/pdf-iframe`
};

export const FILE_TYPE_ICON_URLS = {
    PDF_ICON_URL: "https://cloud-storage.omnicasa.com/share/omnicasa.resources/web-app/icons/Document/pdf.png"
}

export const EXTERNAL_APP_URI = {
    EMAIL_APP: `https://emaileditor.${DEFAULT_DOMAIN}`,
    KANBAN_APP: `https://prospection.${DEFAULT_DOMAIN}`
}
